// src/components/FileUploader/index.js
import React from 'react';

const FileUploaderCV = ({
  type = 'file',
  accept,
  file,
  onChange
}) => {
  return (
    <label
      className="
        border-[0.5px] border-dashed border-[#66666666]
        aspect-video rounded-2xl
        flex items-center justify-center
        max-h-[160px] cursor-pointer
        overflow-hidden        /* keep content inside */
        px-3                   /* space for truncation */
      "
      title={file?.name || 'Upload CV'}
    >
      <input
        className="sr-only"
        type={type}
        accept={accept}
        onChange={onChange}
      />

      {file ? (
        <span
          className="
            block max-w-[90%]
            truncate               /* ellipsis for long names */
            text-sm text-gray-700 text-center
          "
          aria-label={file.name}
        >
          {file.name}
        </span>
      ) : (
        <img src="/assets/upload.svg" alt="upload" />
      )}
    </label>
  );
};

export default FileUploaderCV;
